import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, fromHeight, MOBILE_MID_HEIGHT, TABLET } from '../../../../mediaqueries';

interface UspBlockProps extends ThemeProps<ThemeInterface> {
    isSmall?: boolean;
    isCentralAligned?: boolean;
}
export const UspBlock = styled.div<UspBlockProps>`
    display: none;
    margin: 30px 0 0;
    padding: 0;
    text-align: ${(props: UspBlockProps) => (props.isCentralAligned ? 'center' : 'left')};
    transform: ${(props: UspBlockProps) => (props.isSmall ? 'scale(0.8)' : 'none')};
    padding-left: 10px;

    ${(props: UspBlockProps) => fromHeight[MOBILE_MID_HEIGHT]`
        display: ${props.isSmall ? 'block' : 'none'};
    `}

    ${fromBreakpoint[TABLET]`
        display: block;
    `}
`;
